import { voices } from "@/mocks/platforms";

const principles = [
  { id: "p-1", icon: "ri-scales-3-line", title: "只做整理，不做背书", desc: "榜单是信息汇总，不代表我们为任何平台的内容或立场站台。" },
  { id: "p-2", icon: "ri-eye-line", title: "口径公开可复核", desc: "评分维度和权重全部写在页面上，名次怎么来的，任何人都能自己算。" },
  { id: "p-3", icon: "ri-forbid-2-line", title: "拒绝付费上榜", desc: "不接受任何形式的排名购买，名次只会因为数据变化而变动。" },
  { id: "p-4", icon: "ri-refresh-line", title: "持续复核而非一次性", desc: "每周查热度、每月核口碑，平台一旦掉队就会体现在名次上。" },
];

export default function AboutSection() {
  return (
    <section id="about" className="bg-background-100 py-16 md:py-24 border-y border-background-200">
      <div className="mx-auto max-w-shell px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
          <div className="lg:col-span-5">
            <div className="w-full h-[300px] md:h-[420px] rounded-lg overflow-hidden bg-background-200 border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20minimal%20editorial%20flat%20lay%20of%20stacked%20cream%20paper%20ranking%20cards%2C%20small%20coral%20red%20and%20amber%20gold%20accent%20shapes%2C%20wooden%20desk%20surface%2C%20soft%20natural%20window%20light%2C%20clean%20organized%20composition%2C%20subtle%20grain&width=1000&height=800&seq=guaquan-about-01&orientation=landscape"
                alt="瓜圈榜团队整理榜单的桌面视觉"
                title="瓜圈榜 - 品牌与内容原则"
                className="w-full h-full object-top"
              />
            </div>
          </div>

          <div className="lg:col-span-7">
            <span className="text-xs font-label tracking-[0.2em] text-primary-600 uppercase">About us</span>
            <h2 className="mt-3 font-heading font-bold text-foreground-950 text-2xl md:text-4xl">
              一个只想帮你省时间的榜单站
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              瓜圈榜起步于一群爱看热闹、又懒得一个个翻站点的普通人。我们发现，找吃瓜阵地最大的成本不是信息少，而是噪音太多：同样的消息被转了好几手，热度高的未必靠谱，安静的小站反而内容扎实。
            </p>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
              所以我们做了这件事——把平台按主题归类，用一致的标准打分，把「哪家更新勤、哪家路子稳、哪家只是热闹」摆到同一张桌子上讲清楚。你不需要注册、不需要付费，翻几屏就能有判断。
            </p>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {principles.map((item) => (
                <div key={item.id} className="flex gap-3 rounded-lg bg-background-50 border border-background-200 p-4">
                  <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-100 text-accent-700 shrink-0">
                    <i className={item.icon}></i>
                  </span>
                  <div>
                    <h3 className="font-heading font-semibold text-sm text-foreground-950">{item.title}</h3>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 md:mt-20">
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
            <div>
              <h3 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">榜单用户的真实反馈</h3>
              <p className="mt-2 text-sm text-foreground-600">来自订阅回访与页面留言的整理，未做删改。</p>
            </div>
            <span className="inline-flex items-center gap-2 text-sm text-foreground-500 whitespace-nowrap">
              <i className="ri-chat-quote-line text-primary-500"></i>
              已收到 2,300+ 条反馈
            </span>
          </div>

          <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {voices.map((voice) => (
              <figure key={voice.id} className="rounded-lg bg-background-50 border border-background-200 p-5 md:p-6 flex flex-col">
                <i className="ri-double-quotes-l text-2xl text-primary-300"></i>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700 flex-1">{voice.content}</blockquote>
                <figcaption className="mt-5 flex items-center gap-3 pt-5 border-t border-background-200">
                  <span className="w-10 h-10 rounded-full overflow-hidden bg-background-200 shrink-0">
                    <img src={voice.avatar} alt={`${voice.name}的用户头像`} className="w-full h-full object-top" />
                  </span>
                  <span>
                    <span className="block text-sm font-semibold text-foreground-950">{voice.name}</span>
                    <span className="block text-xs text-foreground-500">{voice.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}